import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Statistic, Table, Select, Space } from 'antd'
import { ArrowUpOutlined, ArrowDownOutlined, RiseOutlined, FallOutlined } from '@ant-design/icons'
import api from '../api'
import dayjs from 'dayjs'

function StatCard({ title, value, precision = 2, prefix, color, icon, bg }) {
  return (
    <Card style={{ borderRadius: 14, border: 'none', background: bg || '#fff', overflow: 'hidden', position: 'relative' }}>
      <div style={{ position: 'absolute', right: 16, top: 16, fontSize: 28, opacity: 0.15 }}>{icon}</div>
      <div style={{ fontSize: 13, color: color ? 'rgba(255,255,255,0.8)' : '#6b7280', fontWeight: 500, marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: color || '#111827' }}>
        {prefix && <span style={{ fontSize: 16, marginRight: 2 }}>{prefix}</span>}
        {typeof value === 'number' ? value.toLocaleString('zh-CN', { minimumFractionDigits: precision, maximumFractionDigits: precision }) : value}
      </div>
    </Card>
  )
}

export default function Dashboard() {
  const [summary, setSummary] = useState(null)
  const [accounts, setAccounts] = useState([])
  const [year, setYear] = useState(dayjs().year())

  useEffect(() => {
    api.get(`/reports/summary?year=${year}`).then(setSummary)
    api.get(`/reports/accounts?start_month=${year}-01&end_month=${year}-12`).then(setAccounts)
  }, [year])

  const years = Array.from({ length: 5 }, (_, i) => dayjs().year() - i)

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#111827' }}>财务总览</div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>King Road Finance · 数据概览</div>
        </div>
        <Space>
          <span style={{ color: '#6b7280', fontSize: 13 }}>年度</span>
          <Select value={year} onChange={setYear} style={{ width: 100 }}>
            {years.map(y => <Select.Option key={y} value={y}>{y} 年</Select.Option>)}
          </Select>
        </Space>
      </div>

      {summary && (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="收入 (RMB)" value={summary.income_rmb} prefix="¥"
              bg="linear-gradient(135deg, #1677ff, #4096ff)" color="#fff" icon={<ArrowUpOutlined />} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="收入 (VND)" value={summary.income_vnd} precision={0}
              bg="linear-gradient(135deg, #0ea5e9, #38bdf8)" color="#fff" icon={<ArrowUpOutlined />} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="支出 (RMB)" value={summary.expense_rmb} prefix="¥"
              bg="linear-gradient(135deg, #f43f5e, #fb7185)" color="#fff" icon={<ArrowDownOutlined />} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="支出 (VND)" value={summary.expense_vnd} precision={0}
              bg="linear-gradient(135deg, #f97316, #fb923c)" color="#fff" icon={<ArrowDownOutlined />} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="盈亏 (RMB)" value={summary.profit_rmb} prefix="¥"
              color={summary.profit_rmb >= 0 ? '#059669' : '#dc2626'}
              icon={summary.profit_rmb >= 0 ? <RiseOutlined /> : <FallOutlined />} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard title="盈亏 (VND)" value={summary.profit_vnd} precision={0}
              color={summary.profit_vnd >= 0 ? '#059669' : '#dc2626'}
              icon={summary.profit_vnd >= 0 ? <RiseOutlined /> : <FallOutlined />} />
          </Col>
        </Row>
      )}

      <Card title="账户余额" style={{ borderRadius: 14 }}>
        <Table
          dataSource={accounts} rowKey="id" pagination={false} size="middle"
          columns={[
            { title: '账户名称', dataIndex: 'name', render: v => <span style={{ fontWeight: 500 }}>{v}</span> },
            { title: '币种', dataIndex: 'currency', width: 80, render: v => (
              <span style={{ background: v === 'RMB' ? '#eff6ff' : '#fff7ed', color: v === 'RMB' ? '#1677ff' : '#f97316', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>{v}</span>
            )},
            { title: '收入', dataIndex: 'total_income', render: v => <span style={{ color: '#059669' }}>{parseFloat(v).toLocaleString('zh-CN')}</span> },
            { title: '支出', dataIndex: 'total_expense', render: v => <span style={{ color: '#dc2626' }}>{parseFloat(v).toLocaleString('zh-CN')}</span> },
            { title: '余额', dataIndex: 'balance', render: v => (
              <span style={{ color: v >= 0 ? '#059669' : '#dc2626', fontWeight: 700, fontSize: 15 }}>
                {parseFloat(v).toLocaleString('zh-CN')}
              </span>
            )},
          ]}
        />
      </Card>
    </div>
  )
}
